
































import 'reflect-metadata'
import { Vue, Component, Watch } from 'vue-property-decorator'
import Chart from 'chart.js'
import { ICurrentValidatorRes } from '@/services/currentValidator/model'
import Loader from '@/components/misc/Loader.vue'
import moment from 'moment'
import { GENESIS_TIME, DAY_MS } from '@/constants'
import ValidatorDataTable from '@/components/Validators/ValidatorDataTable.vue'

@Component({
    components: { Loader, ValidatorDataTable },
    filters: {},
})
export default class ValidatorsHistory extends Vue {
    context: any = null
    chart: Chart | null = null
    minStartTime = 0
    maxEndTime = 0
    data: Map<string, number> = new Map()
    labels: string[] = []
    dataset: number[] = []
    format = 'MM/YY'
    lineColor = ''
    zeroLineColor = ''
    valueColor = ''
    get theme() {
        const data = (this as any).$root.theme
        this.lineColor = data === 'day' ? '#9d43f7' : '#BBF45C'
        this.zeroLineColor = data === 'day' ? '#00000033' : '#FFFFFF33'
        this.valueColor = data === 'night' ? '#fff' : '#9D43F7'
        return data
    }
    validator_initial = ''

    mounted() {
        Chart.platform.disableCSSInjection = true
        this.calculateData()
    }

    get currentValidators() {
        const validators: ICurrentValidatorRes = this.$root.$store.state.Metrics
            .currentValidators
        let startDate = 10000000000
        if (!validators) return null
        const data = this.$root.$store.state.Metrics.currentValidators
            .validators
        data.map((x: any) => {
            if (x.startTime < startDate) {
                startDate = x.startTime
            }
        })
        //  Changing initial month for Graph mapping.
        // getting initial startdate of validator and subtracting month by 1 so that graph can be mapped evenly.
        const currentMonth = Number(moment.unix(startDate).format('MM'))
        const month = currentMonth === 3 ? currentMonth : currentMonth - 1
        let date = moment
            .unix(startDate)
            .format(`YYYY-${month < 10 ? '0' + month : month}-DD`)
        date = date + 'T00:00:00Z'
        this.validator_initial = date
        return validators.validators
    }

    @Watch('currentValidators')
    calculateData() {
        if (!this.currentValidators) return
        //To change the start date of the graph, change it from here.
        this.minStartTime = moment(this.validator_initial).unix()
        this.maxEndTime = parseInt(
            this.currentValidators.at(0)?.endTime ||
                moment(GENESIS_TIME).unix().toString()
        )

        this.currentValidators.map((val) => {
            this.maxEndTime = Math.max(parseInt(val.endTime), this.maxEndTime)
        })

        const startDate = moment(this.minStartTime * 1000)
        const endDate = moment(this.maxEndTime * 1000)
        for (let start = startDate.valueOf(); start <= endDate.valueOf(); ) {
            this.data.set(moment(start).format(this.format), 0)
            start += moment(start).daysInMonth() * DAY_MS
        }
        this.currentValidators.map((_val) => {
            const startDate = moment(parseInt(_val.startTime) * 1000)
            const endDate = moment(parseInt(_val.endTime) * 1000)

            for (
                let start = startDate.valueOf();
                start <= endDate.valueOf();

            ) {
                const itentifier = moment(start).format(this.format)
                if (this.data.has(itentifier)) {
                    let count = this.data.get(itentifier)
                    if (count != undefined) count++
                    else count = 0
                    this.data.set(itentifier, count)
                }

                start += moment(start).daysInMonth() * DAY_MS
            }
        })
        this.data.forEach((count, key) => {
            this.labels.push(key)
            this.dataset.push(count)
        })

        this.drawGraph()
    }

    @Watch('lineColor')
    drawGraph() {
        if (this.currentValidators == null) return
        const stepSize = 6 //set interval for y axis
        const highestNumberOfValidators = Math.max(...this.dataset)
        const rootCanvasRef: any = this.$refs['validators_graph']
        this.context = rootCanvasRef.getContext('2d')
        const _chart = new Chart(this.context, {
            type: 'line',
            data: {
                labels: this.labels,
                datasets: [
                    {
                        data: this.dataset,
                        backgroundColor: 'transparent',
                        borderColor: this.lineColor,
                        borderJoinStyle: 'round',
                        borderWidth: 1,
                        hoverBorderWidth: 4,
                        hoverBorderColor: '#9D43F7',
                        label: 'Validators',
                        pointRadius: 3,
                        pointBackgroundColor: this.lineColor,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    gridLines: {
                        display: false,
                    },
                    xAxes: [
                        {
                            gridLines: {
                                zeroLineColor: this.zeroLineColor,
                                color: 'transparent',
                            },
                            ticks: {
                                fontColor: this.valueColor,
                                fontSize: 16,
                                fontStyle: '600',
                            },
                            stacked: true,
                        },
                    ],

                    yAxes: [
                        {
                            gridLines: {
                                zeroLineColor: this.zeroLineColor,
                                color: 'transparent',
                            },
                            stacked: true,
                            ticks: {
                                fontColor: this.valueColor,
                                fontSize: 16,
                                padding: 10,
                                fontStyle: '600',
                                beginAtZero: true,
                                stepSize: stepSize,
                                max:
                                    Math.round(
                                        (highestNumberOfValidators + stepSize) /
                                            stepSize
                                    ) * stepSize,
                            },
                        },
                    ],
                },
                tooltips: {
                    backgroundColor: 'transparent',
                    mode: 'x-axis',
                    bodyFontColor: '#9D43F7',
                    titleFontSize: 0,
                    bodyFontSize: 14,
                    bodyFontStyle: '600',
                },
                legend: {
                    display: false,
                },
                plugins: {
                    datalabels: {
                        display: false,
                    },
                },
            },
        })
        this.chart = _chart
    }
}
